export default __webpack_public_path__ + "fonts/iot_3.a467dc936b211e0543853fa979daacad.png";